import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const ManagerRouteGuard = ({ children, requireEditRights = false, requireAdministrator = false }) => {
  const [managerProfile, setManagerProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchManagerProfile();
  }, []);

  const fetchManagerProfile = async () => {
    try {
      const token = localStorage.getItem('managerToken');
      if (!token) {
        setLoading(false);
        return;
      }

      const res = await axios.get('/api/manager/profile', {
        headers: { 'x-auth-token': token }
      });
      setManagerProfile(res.data);
    } catch (err) {
      console.error('Error fetching manager profile:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Загрузка...</div>;
  }

  if (!managerProfile) {
    return <Navigate to="/manager/login" replace />;
  }

  // Если требуются права на редактирование, но у менеджера их нет
  if (requireEditRights && !managerProfile.canManageMenu) {
    return <Navigate to="/manager/orders-page" replace />;
  }

  // Если требуется роль администратора, но у менеджера её нет
  if (requireAdministrator && managerProfile.role !== 'administrator') {
    return <Navigate to="/manager/orders-page" replace />;
  }

  return children;
};

export default ManagerRouteGuard;
